import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'

class ProductTabsPlaceholder extends Component {
  render () {
    return (
      <Tabs className={`product-tabs border-color-ui-3 mt-3`}>
        <TabList className='tabs-item  row py-3 border-color-ui-3 border-bottom px-0 mx-0'>
          <Tab className='item-button item-button-inactive col-3 px-2 txt-circular-black txt-uppercase txt-body'>
            <div className='row'>
              <div className='col-12 pr-half pt-5 radius bg-ui-3' />
            </div>
          </Tab>
          <Tab
            className={`item-button item-button-inactive placeholder col-3 px-2 txt-circular-black txt-uppercase txt-body`}
          >
            <div className='row'>
              <div className='col-12 pr-half pt-5 radius bg-ui-3' />
            </div>{' '}
          </Tab>
          <Tab className='item-button item-button-inactive col-3 px-2 txt-circular-black txt-uppercase txt-body'>
            <div className='row'>
              <div className='col-12 pr-half pt-5 radius bg-ui-3' />
            </div>{' '}
          </Tab>
        </TabList>
        <TabPanel className='row px-2 mx-0'>
          <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
            <div className='row'>
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-6 pr-half pt-1 radius bg-ui-3' />
            </div>
          </div>
        </TabPanel>
        <TabPanel className={`row px-2 mx-0`}>
          <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
            <div className='row'>
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-6 pr-half pt-1 radius bg-ui-3' />
            </div>
          </div>
        </TabPanel>
        <TabPanel className='row px-2 mx-0'>
          <div className='item-content py-3 col-12 txt-font-body txt-body-sm color-ui-2'>
            <div className='row'>
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-12 pr-half pt-1 radius bg-ui-3 mb-1' />
              <div className='col-6 pr-half pt-1 radius bg-ui-3' />
            </div>
          </div>
        </TabPanel>
      </Tabs>
    )
  }
}

export default ProductTabsPlaceholder



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/DetailSection/ProductTabs/ProductTabsPlaceholder.js